import Isotope from 'isotope-layout';
import { Select, On } from '../../helper/helper';

const IsotopeJS = {
  init() {
    this._initialListener();
  },


  _initialListener() {
    window.addEventListener(
      'load',
      () => {
        this._isotopeFilter();
      }
    );
  },


  _isotopeFilter () {
    const galeriItemsContainer = Select('.galeri-items-container');
    if (!galeriItemsContainer) return;

    this._buttonUIFilter(galeriItemsContainer);
  },


  _buttonUIFilter(galeriItemsContainer) {
    const galeriFilters = Select('#galeri-filters li', true);       
    const portfolioIsotope = new Isotope(
      galeriItemsContainer,
      {
        itemSelector: '.galeri-item',
        layoutMode: 'masonry' //'fitRows'
      }
    );

    this._buttonUIActions(galeriFilters, portfolioIsotope);
  },


  _buttonUIActions(galeriFilters, portfolioIsotope) {
    On ('click', '#galeri-filters li', (event) => {
      event.preventDefault();
      
      if (event.target.tagName !== 'A') return;
      const thisElemet = event.target.parentElement;
      this._buttonUIEvent({ thisElemet, galeriFilters, portfolioIsotope });
    }, true);
  },


  _buttonUIEvent({ thisElemet, galeriFilters, portfolioIsotope }) {
    
    galeriFilters.forEach((element) => {
      element.classList.remove('filter-active');
    });

    thisElemet.classList.add('filter-active');
    portfolioIsotope.arrange({
      filter: thisElemet.getAttribute('data-filter')
    });
  }
};

export default IsotopeJS;